import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";
import Icon from "./Icons";

const Landing = () => {
  const { t } = useTranslation();
  const heroImage = `${process.env.PUBLIC_URL}/assets/hero-optical.jpg`;

  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <section className="hero-section">
      <img
        src={heroImage}
        alt=""
        aria-hidden="true"
        className="hero-image"
        width="1200"
        height="628"
        decoding="async"
        fetchpriority="high"
      />
      <div className="hero-overlay" aria-hidden="true" />
      <div className="page-container hero-container">
        <div className="hero-content">
          <p className="eyebrow">{t("hero_eyebrow")}</p>
          <h1 className="hero-title">L3 Route</h1>
          <p className="hero-lead">{t("hero_lead")}</p>

          <div className="hero-actions">
            <button
              type="button"
              className="primary-action"
              onClick={scrollToContact}
            >
              <span>{t("hero_cta")}</span>
              <Icon name="arrowRight" />
            </button>
          </div>
        </div>

        <div className="hero-metrics" aria-label={t("hero_metrics_label")}>
          <div>
            <strong>{t("metric_one_value")}</strong>
            <span>{t("metric_one_label")}</span>
          </div>
          <div>
            <strong>{t("metric_two_value")}</strong>
            <span>{t("metric_two_label")}</span>
          </div>
          <div>
            <strong>{t("metric_three_value")}</strong>
            <span>{t("metric_three_label")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Landing;
